import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GuestBirthdayNoticeId {
  BIRTHDAY_DAY = 1,
  ARRIVAL_DAY = 2,
  ONE_DAY_BEFORE_ARRIVAL = 3,
  TWO_DAYS_BEFORE_ARRIVAL = 4,
  THREE_DAYS_BEFORE_ARRIVAL = 5,
  ONE_WEEK_BEFORE_ARRIVAL = 6,
  TWO_WEEKS_BEFORE_ARRIVAL = 7,
}

export class GuestBirthdayNotice extends Codebook<GuestBirthdayNoticeId> {
  static readonly BIRTHDAY_DAY = new GuestBirthdayNotice(GuestBirthdayNoticeId.BIRTHDAY_DAY, () =>
    $t('On birthday'),
  )
  static readonly ARRIVAL_DAY = new GuestBirthdayNotice(GuestBirthdayNoticeId.ARRIVAL_DAY, () =>
    $t('On the day of arrival'),
  )
  static readonly ONE_DAY_BEFORE_ARRIVAL = new GuestBirthdayNotice(
    GuestBirthdayNoticeId.ONE_DAY_BEFORE_ARRIVAL,
    () => $t('1 day before arrival'),
  )
  static readonly TWO_DAYS_BEFORE_ARRIVAL = new GuestBirthdayNotice(
    GuestBirthdayNoticeId.TWO_DAYS_BEFORE_ARRIVAL,
    () => $t('2 days before arrival'),
  )
  static readonly THREE_DAYS_BEFORE_ARRIVAL = new GuestBirthdayNotice(
    GuestBirthdayNoticeId.THREE_DAYS_BEFORE_ARRIVAL,
    () => $t('3 days before arrival'),
  )
  static readonly ONE_WEEK_BEFORE_ARRIVAL = new GuestBirthdayNotice(
    GuestBirthdayNoticeId.ONE_WEEK_BEFORE_ARRIVAL,
    () => $t('1 week before arrival'),
  )
  static readonly TWO_WEEKS_BEFORE_ARRIVAL = new GuestBirthdayNotice(
    GuestBirthdayNoticeId.TWO_WEEKS_BEFORE_ARRIVAL,
    () => $t('2 week before arrival'),
  )

  private constructor(
    public readonly id: GuestBirthdayNoticeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
